import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HTTPService, HelperService, GeoLocationService } from 'app/services';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss'],
})
export class ChangePasswordComponent implements OnInit {
  public userId: string = '';
  public data = {
    newPassword: '',
    confirmPassword: '',
  };
  public errors = {
    newPassword: '',
    confirmPassword: '',
  };
  validationRules: { key: string; message: string; valid: boolean }[] = [];
  public isProcessing: boolean = false;
  isOnboarding: boolean = false;

  constructor(private httpService: HTTPService, private helperService: HelperService, private dialogConfig: DynamicDialogConfig, private dialogRef: DynamicDialogRef, 
    private geoLocationService: GeoLocationService) { }

  ngOnInit() {
    const { userId, isOnboarding } = this.dialogConfig.data;
    this.validationRules = this.helperService.strongPassword(this.data);
    this.isOnboarding = isOnboarding;
    this.userId = userId;
  }

  /**
   * On field focus
   * @param name fieldName
   */
  public handleFocus(name): void {
    this.errors[name] = '';
  }

  /**
   * On field blur
   * @param name fieldName
   */
  public handleBlur(name): void {
    // if (!this.data[name]) {
    //   if (name === 'password') {
    //     this.errors[name] = 'Password is required';
    //   }
    //   if (name === 'confirmPassword') {
    //     this.errors[name] = 'Confirm password is required';
    //   }
    // } else {
    //   if (this.data.password && this.data.confirmPassword && this.data.password !== this.data.confirmPassword) {
    //     this.errors.confirmPassword = 'Password & confirm password are not same';
    //   }
    // }
  }

  /**
   * On field value change
   *
   * @param name fieldName
   * @param value value
   */
  handleChange(name, value) {
    this.data[name] = value;
    this.validationRules = this.helperService.strongPassword(this.data);
  }

  /**
   * Validate all fields
   */
  public validate(): boolean {
    let isValid = true;

    // if (!this.data.password) {
    //   this.errors.password = 'New Password is required';
    //   isValid = false;
    // }

    // if (!this.data.confirmPassword) {
    //   this.errors.confirmPassword = 'Confirm Password is required';
    //   isValid = false;
    // }

    // if (this.data.password && this.data.confirmPassword && this.data.password !== this.data.confirmPassword) {
    //   this.errors.confirmPassword = 'Password & confirm password are not same.';
    //   isValid = false;
    // }

    if (!this.isFormValid()) {
      isValid = false;
    }
    return isValid;
  }

  // Method to check if all validation rules are satisfied
  isFormValid(): boolean {
    return this.validationRules.every(rule => rule.valid);
  }

  /**
   * Change password
   */
  public async changePassword(): Promise<void> {
    try {
      if (this.validate() && !this.isProcessing) {
        // if (!this.validate() || this.isProcessing) {
        //   return;
        // }

        this.isProcessing = true;
        await this.httpService.changeUserPassword(this.userId, this.data.newPassword, this.isOnboarding,'');
        this.helperService.showToaster('success', 'Updated successfully');
         // record login activity
         this.geoLocationService.getGeoInfo().then((info: any) => {
          const payload = {
            info,
            action: 'PASSWORD_UPDATED_BY_SUPPORT',
          };
          this.httpService.recordAuthActivityLogs(payload).catch((err) => console.error(err));
        });
        this.close();
      }
    } catch (error) {
      this.helperService.showToaster('error', error);
    } finally {
      this.isProcessing = false;
    }
  }



  /**
   * Close Dialog
   */
  public close(): any {
    this.dialogRef.close();
  }
}
